import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"value":_vm.value,"append-icon":"mdi-magnify","label":_vm.label,"placeholder":_vm.placeholder,"filled":"","rounded":"","dense":"","single-line":"","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }